var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-form table-responsive" }, [
    _c("table", { staticClass: "table" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.invoiceList, function (invoice) {
          return _c("tr", { key: invoice.id }, [
            _c("th", [_vm._v(_vm._s(invoice.invoiceId))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(invoice.proformaInvoiceId))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(invoice.totalAmount))]),
            _vm._v(" "),
            _c("th", [
              _vm._v(_vm._s(_vm._f("ddMMyyyyHHmmSS")(invoice.createDate))),
            ]),
            _vm._v(" "),
            _c("th", [
              _vm.userListMap
                ? _c("span", [
                    _vm._v(_vm._s(_vm.userListMap[invoice.createdBy].email)),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            invoice.cancelDate
              ? _c("th", [
                  _vm._v(_vm._s(_vm._f("ddMMyyyyHHmmSS")(invoice.cancelDate))),
                ])
              : _c("th"),
            _vm._v(" "),
            invoice.cancelledBy
              ? _c("th", [
                  _vm.userListMap
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.userListMap[invoice.cancelledBy].email)
                        ),
                      ])
                    : _vm._e(),
                ])
              : _c("th"),
            _vm._v(" "),
            _c(
              "th",
              [
                _c("invoice-status", {
                  attrs: { "invoice-status": invoice.status },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("th", [
              _c(
                "div",
                {
                  staticClass: "clickable-text",
                  on: {
                    click: function ($event) {
                      return _vm.downloadInvoice(invoice.documentStoreId)
                    },
                  },
                },
                [_c("span", [_vm._v("İndir")])]
              ),
            ]),
            _vm._v(" "),
            _c("th", [
              _c(
                "div",
                {
                  staticClass: "clickable-text",
                  on: {
                    click: function ($event) {
                      return _vm.cancelInvoice(invoice.id)
                    },
                  },
                },
                [
                  invoice.status == "new" || invoice.status == "paid"
                    ? _c("span", [_vm._v("İptal")])
                    : _vm._e(),
                ]
              ),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Fatura Numarası")]),
        _vm._v(" "),
        _c("th", [_vm._v("Proforma Numarası")]),
        _vm._v(" "),
        _c("th", [_vm._v("Toplam Tutar")]),
        _vm._v(" "),
        _c("th", [_vm._v("Üretim Tarihi")]),
        _vm._v(" "),
        _c("th", [_vm._v("Üreten Kişi")]),
        _vm._v(" "),
        _c("th", [_vm._v("İptal Tarihi")]),
        _vm._v(" "),
        _c("th", [_vm._v("İptal Eden Kişi")]),
        _vm._v(" "),
        _c("th", [_vm._v("Durum")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }